import React from 'react'
import CartSection from './Partial/CartSection'
import Breadcrum from './Partial/Breadcrum'
import Menubar from './Partial/Menubar'

export default function Cart() {
    return (
        <>
            <Menubar title="Cart Page" />
            <CartSection title="Cart" />
        </>
    )
}
